import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, Input, ChangeDetectorRef } from '@angular/core';
import { ClientSubscriptionFreezeStatus, ClientSubscriptionFreezeType, PaymentDerivedStatus } from '@fitness-force/enum';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'freeze-type',
  templateUrl: './freeze-type.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule]
})
export class FreezeTypeComponent implements OnInit {
  @Input() additionData = new BehaviorSubject(null);
  @Input() columnData  = new BehaviorSubject(null);
  type!: any;
  constructor(private cd: ChangeDetectorRef) { }
  ngOnInit() {
  }


  getFreezeType(value:any){
    return ClientSubscriptionFreezeType[value]
  }

}